var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base64 } from 'js-base64';
export class JW3TSigner {
    constructor(signer, content) {
        this._signer = signer;
        this._content = content;
    }
    getSignature() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._signer) {
                throw new Error('no signer is set for signing the token');
            }
            if (!this._content) {
                throw new Error('no content is set to be signed.');
            }
            let jsonStrContent = this._content.stringify();
            let base64Content = this._content.toBase64Url();
            let sig = yield this._signer.sign(jsonStrContent);
            let base64Sig = Base64.fromUint8Array(sig, true);
            return { base64Content, base64Sig };
        });
    }
}
